export default "__VITE_ASSET__DNtIxkfW__"